import OnboardingPage from "@app/pages/onboarding/onboarding-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute, useSearch } from "@tanstack/react-router";

type OnboardingSearch = {
  token?: string;
  oauth?: string;
  oauth_error?: string;
};

export const Route = createFileRoute("/onboarding")({
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
    oauth: typeof search.oauth === "string" ? search.oauth : undefined,
    oauth_error:
      typeof search.oauth_error === "string" ? search.oauth_error : undefined,
  }),
  head: () => pageHead("Onboarding"),
  component: OnboardingRoute,
});

function OnboardingRoute() {
  const { token, oauth, oauth_error } = useSearch({ from: "/onboarding" });
  return (
    <OnboardingPage
      token={token}
      providerDone={oauth === "done"}
      oauthError={oauth_error}
    />
  );
}
